<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Relación</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(indirectPep, index) in getIndirectPeps"
          :key="index">
          <td>
            {{ indirectPep.name }}
            {{ indirectPep.middle_name }}
            {{indirectPep.last_name }}
          </td>
          <td>{{ relationVerboseName(indirectPep.relationship) }}</td>
          <td>
            <div class="actions-container">
              <button
                class="button button-small button--color button--m"
                @click.prevent="updateIndirectPep(index)">
                Editar
              </button>
              <button
                class="button button-small button--red"
                @click.prevent="deleteIndirectPep(index)">
                Eliminar
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="new-btn--container">
        <button
          class="button button-small button--color"
          @click.prevent="addNewIndirectPep">
          Agregar nuevo
        </button>
    </div>
  </div>
</template>

<script>
import RELATIONS from '@/constants/relations'

export default {
  name: 'IndirectPepsTable',
  data () {
    return {
      RELATIONS
    }
  },
  computed: {
    getIndirectPeps: function () {
      return this.$store.getters['pep/getIndirectPeps']
    }
  },
  methods: {
    relationVerboseName: function (value) {
      const relationName = this.RELATIONS.data.find(item => item.value === value)
      return relationName.name
    },
    addNewIndirectPep: function () {
      this.$emit('displayAllInderectPeps', false)
    },
    updateIndirectPep: function (indirectPepID) {
      this.$store.dispatch('pep/setIndirectPepID', indirectPepID)
      this.$emit('displayAllInderectPeps', false)
    },
    deleteIndirectPep: function (indirectPepID) {
      this.$store.dispatch('pep/deleteIndirectPep', indirectPepID)
      if (this.$store.getters['pep/getIndirectPeps'].length === 0) {
        this.$emit('displayAllInderectPeps', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .button--m {
    margin-bottom: 2em;
    margin-right: 1em;
  }
  .button--red {
    letter-spacing: .1em;
    background:#a91919;
    color: white;
    border: 1px solid #a91919;
  }

  .button--red:hover {
    background: #e24040;
  }

  .new-btn--container {
    margin-top: -1em;
    display: flex;
    justify-content: end;
  }

  .button--color {
    background: #d3dbe1;
    border-color: #acaeb0;
    color: #4d4d4d;
    letter-spacing: .1em;
  }

  .button--color:hover {
    background: #b3c1cb;
  }

  .button-mt {
    margin-top: 3em;
  }

</style>



// WEBPACK FOOTER //
// src/components/IndirectPeps/IndirectPepsTable.vue